/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Col_PrivacyInputs */

const cs_col_privacy = /** @type {(inputs: Col_PrivacyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soukromí`)
};

const en_col_privacy = /** @type {(inputs: Col_PrivacyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacy`)
};

/**
* | output |
* | --- |
* | "Privacy" |
*
* @param {Col_PrivacyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const col_privacy = /** @type {((inputs?: Col_PrivacyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Col_PrivacyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_col_privacy(inputs)
	return cs_col_privacy(inputs)
});